(() => {
  if (customElements.get('payjustnow-product')) return;

  let providerReady;

  function loadProvider() {
    if (typeof window.setPJNProductAmounts === 'function') return Promise.resolve();
    if (!providerReady) {
      providerReady = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://embed.payjustnow.com/product/js/product.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = () => {
          providerReady = undefined;
          script.remove();
          reject(new Error('PayJustNow could not be loaded'));
        };
        document.head.append(script);
      });
    }
    return providerReady;
  }

  class PayJustNowProduct extends HTMLElement {
    connectedCallback() {
      this.connection = {};
      const connection = this.connection;
      queueMicrotask(() => {
        if (!this.isConnected || this.connection !== connection) return;
        this.container = this.querySelector('#pjn-product-container');
        if (!this.container) return;

        this.price = this.dataset.price === '' ? NaN : Number(this.dataset.price);
        this.formId = this.closest('product-rerender')?.getAttribute('observe-form');
        this.controller = new AbortController();
        this.observer = new MutationObserver(() => this.updateAmounts());
        this.observer.observe(this.container, { childList: true, subtree: true });

        document.addEventListener('variant:change', (event) => {
          if (!this.formId || event.detail?.formId !== this.formId) return;
          const price = event.detail?.variant?.price;
          this.price = typeof price === 'number' ? price : NaN;
          this.updateAmounts();
        }, { signal: this.controller.signal });

        this.updateAmounts();
        loadProvider().then(() => {
          if (!this.isConnected || this.connection !== connection) return;
          window.setPJNProductAmounts(Number.isFinite(this.price) ? this.price : 0, 3);
        }).catch(() => {
          if (this.connection === connection) this.hidden = true;
        });
      });
    }

    disconnectedCallback() {
      this.connection = undefined;
      this.controller?.abort();
      this.observer?.disconnect();
    }

    updateAmounts() {
      const payment = this.container.querySelector('#pjn-payment');
      this.hidden = !Number.isFinite(this.price) || this.price <= 0 || !payment;
      if (this.hidden) return;

      const helpLink = [...this.container.querySelectorAll('a')]
        .find((link) => link.textContent.trim() === '?' && !link.hasAttribute('aria-label'));
      if (helpLink) helpLink.setAttribute('aria-label', 'Learn how PayJustNow works');

      const amount = (this.price / 3 / 100).toFixed(2);
      if (payment.textContent !== amount) payment.textContent = amount;
      const instalments = this.container.querySelector('#pjn-instalments');
      if (instalments && instalments.textContent !== '3') instalments.textContent = '3';
    }
  }

  customElements.define('payjustnow-product', PayJustNowProduct);
})();
